import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { AdminSlideMenu } from "../AdminLayout/AdminSlideMenu/AdminSlideMenu";
import { useLanguage } from "../../../contexts";
import { useAuth, useDdMethodology, METHODOLOGIES } from "../../../hooks";
import "./DDNav.scss";

// Ubicación a la derecha de la barra: [grupo, pantalla]
const CRUMBS = {
  "/admin/ocde-guide":         ["Evaluación DD", "Guía OCDE"],
  "/admin/ocde-dd-process":    ["Evaluación DD", "Proceso DD · 6 etapas"],
  "/admin/ocde-risk-register": ["Evaluación DD", "Risk Register · 2.1"],
  "/admin/self-assessments":   ["Evaluación DD", "Autoevaluación · 2.2"],
  "/admin/ocde-cap":           ["Evaluación DD", "CAP Tracker · 3.1"],
  "/admin/bibliography":       ["Recursos", "Bibliografía"],
  "/admin/repository":         ["Recursos", "Repositorio"],
  "/admin/audit-map":          ["Auditorías", "Audit Map"],
  "/admin/policy-tracker":     ["Auditorías", "Policy Lifecycle Tracker"],
};
const FLA_CRUMBS = {
  assess: "Autoevaluación FLA", gap: "Análisis de Brechas FLA", cap: "Plan de Acción FLA", report: "Reporte FLA", guide: "¿Cómo funciona?",
};

export function DDNav() {
  const [menuOpen, setMenuOpen] = useState(false);
  const { pathname, search } = useLocation();
  const navigate = useNavigate();
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;
  const { accessToken } = useAuth();
  const { methodology, methodologyLoading } = useDdMethodology(accessToken);

  const isHome = pathname === "/admin/dd-home";
  const isFla = pathname.startsWith("/admin/fla-assessment");
  const activeMethod = isFla || (isHome && methodology === "fla") ? "fla" : "ocde";
  const isDashboard = pathname === "/admin/dashboard-dd";
  const crumb = isFla
    ? ["Código FLA", FLA_CRUMBS[new URLSearchParams(search).get("v")] || "Ficha de la fábrica"]
    : CRUMBS[pathname];

  return (
    <>
      <AdminSlideMenu open={menuOpen} onClose={() => setMenuOpen(false)} methodology={methodology} />

      <div className="dd-nav">
        {activeMethod === "ocde" && (
          <>
            <button className="dd-nav__menu-btn" onClick={() => setMenuOpen(true)}>
              <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
                <line x1="3" y1="6" x2="21" y2="6" />
                <line x1="3" y1="12" x2="21" y2="12" />
                <line x1="3" y1="18" x2="21" y2="18" />
              </svg>
              {t("menu") !== "menu" ? t("menu") : "Menú"}
            </button>

            <button
              className={`dd-nav__dash-btn${isDashboard ? " active" : ""}`}
              onClick={() => navigate("/admin/dashboard-dd")}
            >
              🏠 Dashboard DD <span className="dd-nav__pill">overview</span>
            </button>
          </>
        )}

        {crumb && (
          <div className="dd-nav__crumb">{crumb[0]} <span>›</span> <b>{crumb[1]}</b></div>
        )}

        <div className="dd-nav__r">
          {/* Con metodología elegida, la otra se oculta: en lugar del selector va la barra «Cambiar» */}
          {!methodologyLoading && methodology && (
            <div className={`dd-nav__meth dd-nav__meth--${methodology}`}>
              Metodología: <b>{METHODOLOGIES[methodology].label}</b>
              <button onClick={() => navigate("/admin/dd-home")}>Cambiar</button>
            </div>
          )}
          {!methodologyLoading && !methodology && (
            <div className="dd-nav__mswitch">
              <button
                className={`dd-nav__mswitch-btn dd-nav__mswitch-btn--fla${activeMethod === "fla" ? " active" : ""}`}
                onClick={() => navigate("/admin/fla-assessment")}
              >
                📝 FLA
              </button>
              <button
                className={`dd-nav__mswitch-btn dd-nav__mswitch-btn--ocde${activeMethod === "ocde" ? " active" : ""}`}
                onClick={() => navigate("/admin/dashboard-dd")}
              >
                🌐 OCDE
              </button>
            </div>
          )}

          {!isHome && <button className="dd-nav__home-btn" onClick={() => navigate("/admin/dd-home")}>Inicio</button>}
        </div>
      </div>
    </>
  );
}
